import { motion } from "framer-motion";
import {
  ShieldCheck,
  Target,
  ScanLine,
  Satellite,
  Users,
  MapPinned,
  Timer,
  FileCheck2,
} from "lucide-react";

const items = [
  { icon: ShieldCheck, title: "DGCA Compliant Operations" },
  { icon: Target, title: "Survey Grade Accuracy" },
  { icon: ScanLine, title: "LiDAR Technology" },
  { icon: Satellite, title: "RTK Enabled Drones" },
  { icon: Users, title: "Dedicated Project Team" },
  { icon: MapPinned, title: "Nationwide Services" },
  { icon: Timer, title: "Fast Turnaround" },
  { icon: FileCheck2, title: "Engineering Deliverables" },
];

export const WhyChoose = () => {
  return (
    <section id="why-choose" className="py-24 bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-widest text-[#8b8f99]">Why Snesar</span>
          <h2 className="mt-3 font-heading text-2xl sm:text-3xl lg:text-4xl font-black text-[#10193f]">
            Built for engineering-grade results
          </h2>
        </div>
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                data-testid={`why-choose-${i}`}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: (i % 4) * 0.06 }}
                className="rounded-sm border border-gray-200 p-6 hover:border-[#10193f]/40 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-sm bg-[#10193f]/5 text-[#10193f]">
                  <Icon className="h-5 w-5" strokeWidth={1.75} />
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-[#10193f]">{it.title}</h3>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
